export default __webpack_public_path__ + "static/media/Checked.2887e858.svg";